import { Box, Grid, Typography } from "@mui/material"
import TIMWheel from "../assets/images/TIMWheel.png";
import { isTimFamilySlug } from "../utils/timFamily";

const fixEncoding = (str) => str ? str.replace(/Ò/g, '®') : str;

const WelcomeReport = ({slug,text,mainImage,howToUse,sectionTitle}) => {

    const isTIM = isTimFamilySlug(slug);
    const displayImage = isTIM ? TIMWheel : mainImage;

    return (
        <>
        <Box sx={{position:"relative",padding:{xs:"24px 16px",sm:"28px 24px",md:"32px 48px 48px"},overflow:"hidden",display:{lg:"flex",xs:"block"},alignItems:"center",minHeight:{lg:"380px",xs:"auto"}}}>
            <Box sx={{position:"absolute",top:"50%",right:48,width:"35%",transform:"translateY(-50%)",display:{xs:"none",lg:"block"}}}>
                <img src={displayImage} alt="Assessment Logo" style={{width:"100%",maxWidth:"400px",objectFit:"contain"}}/>
            </Box>
            <Box sx={{maxWidth:{lg:"60%",xs:"100%"}}}>
                {sectionTitle && (
                    <Typography variant="h4" color="primary" textAlign="left" fontWeight={400} sx={{marginBottom:"16px"}}>
                        {sectionTitle}
                    </Typography>
                )}
                <Typography component={"div"} variant="body1" color="secondary" fontWeight={400} sx={{marginTop:"8px",lineHeight:"1.7",fontSize:"1.05rem",whiteSpace:"pre-wrap",fontFamily:"'Roboto','Helvetica','Arial',sans-serif","& *":{fontFamily:"inherit !important"},"& p":{marginBottom:"8px",marginTop:"8px"},"& p:first-of-type":{fontWeight:600,fontSize:"1.12rem"},"& p:last-child":{marginBottom:0}}} dangerouslySetInnerHTML={{ __html: fixEncoding(text) }}/>
            </Box>
        </Box>
        {
            !isTimFamilySlug(slug) && howToUse?.length > 0 &&
            <Grid container sx={{margin:"0px",padding:{xs:"20px 16px",sm:"22px 24px",md:"24px 48px 24px"},position:"relative",zIndex:1,backgroundColor:"#fff"}}>
                <Grid size={10}>
                    <Typography variant="h5" color="secondary" fontWeight={600} sx={{marginBottom:"16px"}}>How to Use This Feedback</Typography>
                    <Box sx={{display:"flex",flexDirection:"column",gap:"10px",mt:"4px"}}>
                    {
                        howToUse?.map((p,i)=>(
                            <Box key={i} sx={{display:"flex",alignItems:"flex-start",gap:"10px"}}>
                                <Box sx={{minWidth:20,height:20,display:"flex",alignItems:"center",justifyContent:"center",mt:"3px"}}>
                                    <Box sx={{width:0,height:0,borderTop:"5px solid transparent",borderBottom:"5px solid transparent",borderLeft:"8px solid #69AF45"}}/>
                                </Box>
                                <Typography component={"div"} variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1rem",whiteSpace:"pre-wrap"}} dangerouslySetInnerHTML={{ __html: fixEncoding(p) }}/>
                            </Box>
                        ))
                    }
                    </Box>
                </Grid>
            </Grid>
        }
        </>
    )
}

export default WelcomeReport
